package com.eladfinish.bible.contest.features.installTime.di

import com.eladfinish.bible.contest.features.installTime.platform.AppInstallInfoProvider
import org.koin.dsl.module

actual val installTimePlatformModule
    get() = module {
        single {
            AppInstallInfoProvider()
        }
    }
